<template>
  <div class="content-wrap">
    <div class="user-box">
      <div
        class="user-img"
        :class="{ 'has-certificate': hasCertificate, 'no-certificate': !hasCertificate }"
        @click="openCertificate"
      >
        <img v-if="hasCertificate" :src="certificateUrl" alt="团体会员证书" />
        <div v-else class="cert-placeholder">
          <span>暂无证书</span>
          <em>缴纳会费审核通过后生成</em>
        </div>
      </div>
      <div class="user-info-block">
        <div>
          <span class="user-label">会员名称：</span>
          <span class="user-value">{{ (user.memOrgVo && user.memOrgVo.orgName) || '-' }}</span>
        </div>
        <div>
          <span class="user-label">会员编码：</span>
          <span class="user-value">{{ (user.memOrgVo && user.memOrgVo.memCode) || '-' }}</span>
        </div>
        <div>
          <span class="user-label">通讯地址：</span>
          <span class="user-value">{{ (user.memOrgVo && user.memOrgVo.orgAddress) || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="setting-box">
      <div class="tab-wrap">
        <div class="tab-item" :class="tabActive === 0 ? 'active' : ''" @click="changeTab(0)">账户信息</div>
        <div class="tab-item" :class="tabActive === 1 ? 'active' : ''" @click="changeTab(1)">组织架构</div>
        <div class="tab-item" :class="tabActive === 2 ? 'active' : ''" @click="changeTab(2)">荣获奖项</div>
        <div class="tab-item" :class="tabActive === 3 ? 'active' : ''" @click="changeTab(3)">大 事 记</div>
        <!-- <div class="tab-item" :class="tabActive === 4 ? 'active' : ''" @click="changeTab(4)">专题样式</div> -->
      </div>
      <div class="tab-content-wrap">
        <div class="tab-content" :class="tabClass">
          <div class="tab-content-item">
            <div class="account-tip">标有星号(*)的栏目为必填栏目，并请验证</div>
            <!--<div class="user-img">
              <img :src="user.portraitUrl" alt="" />
              <input  type="file" accept="image/*" @change="onFileChange">
            </div> -->
            <div class="account-item">
              <div class="account-item-label">统一信用代码*</div>
              <div class="account-item-value" v-if="!form.unifiedCreditCode.edit">{{user.memOrgVo.unifiedCreditCode || '-'}}</div>  
              <div class="account-item-value edit"
                  :class="form.unifiedCreditCode.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.unifiedCreditCode.value">
                <span @click="comfirmItem('unifiedCreditCode')">确认</span>
                <span @click="cancelItem('unifiedCreditCode')">取消</span>
                <div class="error-tip">{{form.unifiedCreditCode.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.unifiedCreditCode.edit" @click="editItem('unifiedCreditCode')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">通讯地址*</div>
              <div class="account-item-value" v-if="!form.orgAddress.edit">{{user.memOrgVo.orgAddress || '-'}}</div>  
              <div class="account-item-value edit"
                  :class="form.orgAddress.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.orgAddress.value">
                <span @click="comfirmItem('orgAddress')">确认</span>
                <span @click="cancelItem('orgAddress')">取消</span>
                <div class="error-tip">{{form.orgAddress.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.orgAddress.edit" @click="editItem('orgAddress')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">邮箱*</div>
              <div class="account-item-value" v-if="!form.mailbox.edit">
                <span>{{user.memOrgVo.mailbox || '-'}}</span>
                <div class="account-item-flag" v-if="user.memOrgVo.mailbox"><i></i>已验证</div>
              </div>  
              <div class="account-item-value edit"
                  :class="form.mailbox.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.mailbox.value">
                <span @click="comfirmItem('mailbox')">确认</span>
                <span @click="cancelItem('mailbox')">取消</span>
                <div class="error-tip">{{form.mailbox.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.mailbox.edit" @click="editItem('mailbox')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">传真*</div>
              <div class="account-item-value" v-if="!form.fax.edit">
                <span>{{user.memOrgVo.fax || '-'}}</span>
                <!--<div class="account-item-flag" v-if="user.memOrgVo.fax"><i></i>已验证</div>-->
              </div>  
              <div class="account-item-value edit"
                  :class="form.fax.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.fax.value">
                <span @click="comfirmItem('fax')">确认</span>
                <span @click="cancelItem('fax')">取消</span>
                <div class="error-tip">{{form.fax.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.fax.edit" @click="editItem('fax')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">固定电话</div>
              <div class="account-item-value" v-if="!form.fixedPhone.edit">{{user.memOrgVo.fixedPhone || '-'}}</div>  
              <div class="account-item-value edit"
                  :class="form.fixedPhone.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.fixedPhone.value">
                <span @click="comfirmItem('fixedPhone')">确认</span>
                <span @click="cancelItem('fixedPhone')">取消</span>
                <div class="error-tip">{{form.fixedPhone.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.fixedPhone.edit" @click="editItem('fixedPhone')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">企业简介</div>
              <div class="account-item-value" v-if="!form.memIntroduction.edit">{{user.memOrgVo.memIntroduction || '-'}}</div>  
              <div class="account-item-value edit"
                  :class="form.memIntroduction.error ? 'error' : ''" 
                    v-else>
                <textarea  v-model="form.memIntroduction.value"></textarea>
                <span @click="comfirmItem('memIntroduction')">确认</span>
                <span @click="cancelItem('memIntroduction')">取消</span>
                <div class="error-tip">{{form.memIntroduction.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.memIntroduction.edit" @click="editItem('memIntroduction')">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">企业网址</div>
              <div class="account-item-value" v-if="!form.portalUrl.edit">{{user.memOrgVo.portalUrl || '-'}}</div>  
              <div class="account-item-value edit"
                  :class="form.portalUrl.error ? 'error' : ''" 
                    v-else>
                <input type="text" v-model="form.portalUrl.value">
                <span @click="comfirmItem('portalUrl')">确认</span>
                <span @click="cancelItem('portalUrl')">取消</span>
                <div class="error-tip">{{form.portalUrl.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.portalUrl.edit" @click="editItem('portalUrl')">修改</div>
              </div>      
            </div>
            <div class="account-item" style="margin-bottom:52px">
              <div class="account-item-label">logo上传</div>
              <div class="account-item-value" v-if="!form.logoUrl.edit">
                <img :src="user.memOrgVo.logoUrl" alt="" />
              </div>  
              <div class="account-item-value edit"
                  :class="form.logoUrl.error ? 'error' : ''" 
                    v-else>
                <img v-if="form.logoUrl.value" :src="form.logoUrl.value" alt="" />
                <div class="upload-add">
                  上传logo
                  <input type="file" @change="(e)=>onFileChange(e,'logo')" />
                </div>
                <div class="warn-tip">建议上传尺寸为：280*160，大小限制为：500kb</div>
                <span @click="comfirmItem('logoUrl')">确认</span>
                <span @click="cancelItem('logoUrl')">取消</span>
                <div class="error-tip">{{form.logoUrl.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.logoUrl.edit" @click="editLogo()">修改</div>
              </div>      
            </div>
            <div class="account-item">
              <div class="account-item-label">会员主题图</div>
              <div class="account-item-value" v-if="!form.portalTopUrl.edit">
                <img :src="user.memOrgVo.portalTopUrl" alt="" />
              </div>  
              <div class="account-item-value edit"
                  :class="form.portalTopUrl.error ? 'error' : ''" 
                    v-else>
                <img v-if="form.portalTopUrl.value" :src="form.portalTopUrl.value" alt="" />
                <div class="upload-add" style="width:113px">
                  上传主题图
                  <input type="file" @change="(e)=>onFileChange(e,'portalTop')" />
                </div>
                <div class="warn-tip">建议上传尺寸为：3840*1920，大小限制为：2M</div>
                <span @click="comfirmItem('portalTopUrl')">确认</span>
                <span @click="cancelItem('portalTopUrl')">取消</span>
                <div class="error-tip">{{form.portalTopUrl.error}}</div>
              </div>  
              <div class="account-item-op">
                <div class="edit-op" v-if="!form.portalTopUrl.edit" @click="editPortalTopUrl()">修改</div>
              </div>      
            </div>    
          </div>
          <div class="tab-content-item organization-item">
            <div class="search-header">
              <div class="search-box">
                <div class="search-input-box"><input type="text" v-model="linkman"></div>
                <div class="search-btn" @click="getMemOrgLinkList">
                  <i></i>
                  <span>搜索</span>
                </div>
              </div>
              <div class="search-header-extra">
                <div class="add-contact" @click="onOpenContactModal">添加联系人</div>
              </div>
            </div>
            <div class="search-table">
              <Table :columns="columns" :rows-data="rowsData">
                <template slot-scope='scope'>
                  <div v-if="scope.col.key === 'op' && (scope.row.isMain == 0 || !scope.row.isMain)" class="table-op">
                    <a @click="onEdit(scope.row)">编辑</a>
                    <span class="split-line"></span>
                    <a class="del" @click="onDelete(scope.row)">删除</a>
                  </div>
                </template>
              </Table>
            </div>
          </div>
          <WinAward class="tab-content-item"></WinAward>
          <GreatEvent class="tab-content-item"></GreatEvent>
          <div class="tab-content-item">
            <Empty />
          </div>
        </div>
      </div>
    </div>
    <Modal :visible="contactVisible">
      <ContactModal 
        :formData="contactForm"
        @confirm="onContactConfirm"
        @cancel="onContactModalClose"
      />
    </Modal>
  </div>
</template>

<script>
import ContactModal from './components/ContactModal';
import GreatEvent from './components/GreatEvent.vue';
import Modal from '@/components/Modal';
import modal from '@/components';
import Table from '@/components/Table';
import upload from '@/service/upload';
import { mapState, mapActions } from 'vuex';
import { resetUserOrg, getMemOrgLinkList, addMemOrgLink, removeMemOrgLink, editMemOrgLink, getMemOrgLinkDetail } from './service/api';
import WinAward from './components/WinAward.vue';

const phoneReg = /^(13|15|17|18|14)[0-9]{9}$/;
const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
const postDicKey = [{
  value: 1301,
  name: '法人'
},
{
  value: 1302,
  name: '总经理'
},
{
  value: 1303,
  name: '办公室主任'
},
{
  value: 1304,
  name: '财务主管'
},
{
  value: 1305,
  name: '工作人员'
}]
export default {
  data() {
    return {
      loading: false,
      linkman: '',
      tabActive: 0,
      contactVisible: false,
      contactForm: {
        linkman: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.contactForm.linkman.error = '请输入姓名';
              return false;
            }
            return true;
          }
        },
        postDicKey: {
          value: '',
          error: false,
          options: postDicKey
        },
        officePhone: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.contactForm.officePhone.error = '请输入固定电话';
              return false;
            }
            return true;
          }
        },
        mobilePhone: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.contactForm.mobilePhone.error = '请输入移动电话';
              return false;
            }
            if (!phoneReg.test(v)) {
              this.contactForm.mobilePhone.error = '手机号不合法';
              return false;
            }
            return true;
          }
        },
        mailbox: {
          value: '',
          error: false,
          validate: v => {
            if (!v) {
              this.contactForm.mailbox.error = '请输入邮箱';
              return false;
            }
            if (!mailReg.test(v)) {
              this.contactForm.mailbox.error = '邮箱地址不合法';
              return false;
            }
            return true;
          }
        },
      },
      form: {
        unifiedCreditCode: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.unifiedCreditCode.error = '请输入统一信用代码';
              return false;
            }
            return true;
          }
        },
        orgAddress: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.orgAddress.error = '请输入通讯地址';
              return false;
            }
            return true;
          }
        },
        mailbox: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.mailbox.error = '请输入邮箱';
              return false;
            }
            if (!mailReg.test(v)) {
              this.form.mailbox.error = '邮箱地址不合法';
              return false;
            }
            return true;
          }
        },
        fax: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.fax.error = '请输入传真';
              return false;
            }
            return true;
          }
        },
        fixedPhone: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.fixedPhone.error = '请输入固定电话';
              return false;
            }
            return true;
          }
        },
        memIntroduction: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.memIntroduction.error = '请输入企业简介';
              return false;
            }
            return true;
          }
        },
        portalUrl: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.portalUrl.error = '请输入企业网址';
              return false;
            }
            return true;
          }
        },        
        logoUrl: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.logoUrl.error = '请上传图片';
              return false;
            }
            return true;
          }
        },
        portalTopUrl: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.portalTopUrl.error = '请上传图片';
              return false;
            }
            return true;
          }
        }
      },
      columns: [{
        key: 'linkman',
        dataIndex: 'linkman',
        name: '姓名'
      }, {
        key: 'isMain',
        dataIndex: '_isMain',
        name: '是否主账号'
      }, {
        key: 'postDicKey',
        dataIndex: 'postDicText',
        name: '职务'
      }, {
        key: 'officePhone',
        dataIndex: 'officePhone',
        name: '办公电话'
      }, {
        key: 'mobilePhone',
        dataIndex: 'mobilePhone',
        name: '移动电话'
      }, {
        key: 'mailbox',
        dataIndex: 'mailbox',
        name: '邮箱'
      }, {
        key: 'op',
        name: '操作'
      }],
      rowsData: []
    }
  },
  computed: {
    ...mapState(['user']),
    tabClass() {
      return `tab-content-${this.tabActive}`;
    },
    certificateUrl() {
      return (this.user && this.user.memOrgVo && this.user.memOrgVo.certificateUrl) || '';
    },
    hasCertificate() {
      return !!this.certificateUrl;
    },
  },
  components: {
    Modal,
    ContactModal,
    Table,
    GreatEvent,
    WinAward,
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(['getUserInfo']),
    init() {
      this.getMemOrgLinkList();
    },
    getMemOrgLinkList() {
      if (!this.user || !this.user.memOrgVo || !this.user.memOrgVo.id) {
        return;
      }
      getMemOrgLinkList({
        linkman: this.linkman,
        orgId: this.user.memOrgVo.id
      }).then(res => {
        this.rowsData = (res || []).map(item => {
          if (item.postDicKey) {
            const target = postDicKey.find(dic => dic.value == item.postDicKey);
            item.postDicText = target ? target.name : '-';
          }
          item._isMain = item.isMain == 1 ? '是' : '-';
          return item;
        });
      })
    },
    onFileChange($event,type) {
			const file = $event.target.files[0];
			if (this.loading) return false;
			this.loading = true;
			upload(file).then(url => {
        if(type == 'logo'){
          this.form.logoUrl.value = url;
        }
        if(type == 'portalTop'){
          this.form.portalTopUrl.value = url;
        }
        // const params = {
        //   id: this.user.memId,
        //   // portraitUrl: url
        // }
				// resetUserOrg(params).then(() => {
        //   this.getUserInfo();
        //   this.$message({
        //     type: 'success',
        //     content: '操作成功'
        //   });
        // }).catch(err => {
        //   this.$message({
        //     type: 'error',
        //     content: err
        //   });
        // });
			}).finally(() => {
				this.loading = false;
			})
		},    
    editItem(fieldName) {
      const field = this.form[fieldName];
      field.value = this.user.memOrgVo[fieldName];
      field.edit = true;
    },
    editLogo() {
      this.form.logoUrl.value = this.user.logoUrl;
      this.form.logoUrl.edit = true;
    },
    editPortalTopUrl() {
      this.form.portalTopUrl.value = this.user.portalTopUrl;
      this.form.portalTopUrl.edit = true;
    },
    
    comfirmItem(fieldName) {
      const field = this.form[fieldName];
      if (field.validate && !field.validate(field.value)) {
        return false;
      };
      field.error = false;
      const params = {
        id: this.user.memId,
        [fieldName]: field.value
      }
      resetUserOrg(params).then(() => {
        this.cancelItem(fieldName);
        this.getUserInfo();
        this.$message({
          type: 'success',
          content: '操作成功'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          content: err
        });
      })
    },
    cancelItem(fieldName) {
      const field = this.form[fieldName];
      field.error = false;
      field.edit = false;
    },
    changeTab(idx) {
      this.tabActive = idx;
    },
    onEdit(row) {
      this.contactForm.id = row.id;
      this.contactForm.linkman.value = row.linkman;
      this.contactForm.mailbox.value = row.mailbox;
      this.contactForm.mobilePhone.value = row.mobilePhone;
      this.contactForm.officePhone.value = row.officePhone;
      this.contactForm.postDicKey.value = row.postDicKey;
      this.contactVisible = true;
    },
    onDelete(row) {
      modal.confirm({
        title: '请确认是否删除该联系人？',
        confirm:() => {
          return removeMemOrgLink({
            id: row.id
          }).then(() => {
            this.getMemOrgLinkList();
            this.$message({
              type: 'success',
              content: '删除成功'
            });
          }).catch(err => {
            this.$message({
              type: 'error',
              content: err
            });
          });
        },
      });
    },
    onOpenContactModal() {
      this.contactForm.id = '';
      this.contactForm.linkman.value = '';
      this.contactForm.mailbox.value = '';
      this.contactForm.mobilePhone.value = '';
      this.contactForm.officePhone.value = '';
      this.contactForm.postDicKey.value = '';
      this.contactVisible = true;
    },
    onContactConfirm() {
      const params = {
        orgId: this.user.memOrgVo.id,
        linkman: this.contactForm.linkman.value,
        mailbox: this.contactForm.mailbox.value,
        mobilePhone: this.contactForm.mobilePhone.value,
        officePhone: this.contactForm.officePhone.value,
        postDicKey: this.contactForm.postDicKey.value
      }
      let apiFunc = addMemOrgLink;
      if (this.contactForm.id) {
        params.id = this.contactForm.id;
        apiFunc = editMemOrgLink;
      }
      apiFunc(params).then(() => {
        this.getMemOrgLinkList();
        this.onContactModalClose();
        this.$message({
          type: 'success',
          content: '操作成功'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          content: err
        });
      })
    },
    onContactModalClose() {
      this.contactVisible = false;
    },
    openCertificate(){
      if (!this.hasCertificate) {
        return;
      }
      window.open(this.certificateUrl, '_blank');
    },
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  width: 1008px;
}
.edit-op {
  cursor: pointer;
  padding-left: 24px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #06AE63;
  background: url(../../assets/images/icon-edit.png) no-repeat 0
    center;
  background-size: 16px 16px;
}
.edit-link.edit-op {
  background-image: url(../../assets/images/icon-link.png);
}
.user-box {
  width: 100%;
  height: 160px;
  background: url(../../assets/images/member-user-info-bg.png) no-repeat center
    center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 40px;
  background: #FFFFFF;
  margin-bottom: 12px;

  .user-img {
    width: 200px;
    height: 137px;
    margin-right: 60px;
    border: 4px solid #06AE63;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background: #f7f8fa;

    &.no-certificate {
      border-color: #d9d9d9;
    }

    &:hover {
      position: relative;

      &::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .3) url(../../assets/images/icon-view.png) no-repeat center center;
        background-size: 20px 20px;
      }
    }

    > img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cert-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #8c8c8c;
      font-size: 14px;
      line-height: 1.5;
      text-align: center;
      padding: 12px;
      box-sizing: border-box;

      em {
        font-style: normal;
        font-size: 12px;
        margin-top: 4px;
        color: #bfbfbf;
      }
    }

     > input {
      position: absolute;
      cursor: pointer;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
  }

  .user-flag {
    width: 90px;
    height: 32px;
    background: #e9e9e9;
    border-radius: 0px 0px 0px 12px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;

    &.certification {
      background: #ff7a45;
    }
  }

  .user-info-block {
    margin-right: 60px;

    > div {
      // &:first-child {
      //   margin-bottom: 20px;
      // }
      margin-bottom: 20px;
      margin-top: 20px;
      .user-label {
        width: 80px;
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
        line-height: 16px;
      }

      .user-value {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131415;
        line-height: 16px;
      }
    }
  }
}
.setting-box {
  padding: 40px;
  background: #FFFFFF;
  margin-bottom: 12px;
}
.tab-wrap {
  border-bottom: 1px solid #EEEEEE;
  display: flex;

  .tab-item {
    margin-right: 80px;
    padding-bottom: 19px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    
    &:hover, &.active {
      color: #06AE63;
      border-bottom: 1px solid #06AE63;
    }
  }
}
.tab-content-wrap {
  width: 100%;
  overflow: hidden;

  .tab-content {
    width: 500%;
    display: flex;
    transform: translateX(0);
    transition: all .5s;

    &.tab-content-1 {
      transform: translateX(-20%);
    }

    &.tab-content-2 {
      transform: translateX(-40%);
    }

    &.tab-content-3 {
      transform: translateX(-60%);
    }

    &.tab-content-4 {
      transform: translateX(-80%);
    }

    &-item {
      flex: 1;
      padding-top: 20px;
      .account-tip {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
        margin-bottom: 30px;
      }

      .account-item {
        margin-bottom: 35px;
        height: 32px;
        display: flex;
        align-items: center;

        &.account-illegal {
          .account-item-value {
            span {
              display: none;
            }
          }

          .account-item-flag {
            background: rgba(255,59,47,0.0600);
            color: #FF3B2F;
          }
        }

        &-label {
          width: 120px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
          margin-right: 40px;
        }

        &-value {
          display: flex;
          align-items: center;

          > img {
            display: block;
            width: 50px;
            height: 50px;
          }

          &.edit {
            position: relative;

            .error-tip {
              position: absolute;
              left: 0;
              top: 100%;
              font-size: 12px;
              color: #FF3B2F;
              line-height: 20px;
              display: none;
              margin-top:18px
            }
            .warn-tip {
              position: absolute;
              left: 0;
              top: 100%;
              font-size: 13px;
              color: #787878;
              line-height: 20px;
              width:400px
            }
            

            &.error {

              > input {
                border: 1px solid #FF3B2F;
              }

              .error-tip {
                display: block;
              }
            }

            .upload-add {
              margin: 0 20px 0px 0px;
              padding: 10px;
              color: #ffffff;
              border-radius: 5px;
              width: 100px;
              padding-left: 30px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              background: #06ae63 url(../../assets/images/icon-upload.png) no-repeat 5px
                center;
              background-size: 20px 20px;
              position: relative;

              &.loading {
                background-image: url(../../assets/images/icon-loading.gif);
                background-position: center center;
              }

              > input {
                position: absolute;
                cursor: pointer;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
              }
            }

            > input[type="text"] {
              background: #F5F5F5;
              margin-right: 20px;
              width: 250px;
              height: 32px;
              padding: 0 16px;
            }

            > textarea {
              width: 380px;
              height: 55px;
              display: block;
              resize: none;
              box-sizing: border-box;
              border: none;            
              padding: 0 16px;
              background: #F5F5F5;
            }

            > span {
              margin-right: 5px;
              cursor: pointer;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #06AE63;
            }

            > select {
              width: 250px;
              height: 32px;
              background: #FFFFFF;
              border-radius: 2px;
              border: 1px solid #E6E7EB;
              outline: none;
              text-align: center;

              option {
                width: 41px;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #1B2841;
                line-height: 22px;
              }
            }
          }

          > span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            margin-right: 17px;
          }
        }

        &-flag {
          width: 76px;
          height: 28px;
          background: rgba(6,174,99,0.1000);
          color: #06AE63;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          margin-right: 12px;

          > i {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            background: url(../../assets/images/icon-check.png) no-repeat center
              center;
            background-size: 100% 100%;
          }
        }

        .acount-item-tip {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #787878;
        }

        &-op {
          margin-left: auto;
        }
      }
    }
  }
}
.organization-item {
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .search-box {
      display: flex;
      align-items: center;

      .search-input-box {
        padding: 0 16px;
        height: 30px;
        background: #F5F5F5;

        input {
          width: 300px;
          height: 100%;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #131415;
        }
      }

      .search-btn {
        width: 80px;
        height: 30px;
        cursor: pointer;
        background: #06AE63;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          width: 24px;
          height: 24px;
          margin-right: 4px;
          background: url(../../assets/images/icon-search.png) no-repeat center
            center;
          background-size: 100% 100%;
        }

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }

    .search-header-extra {
      margin-left: auto;
      
      .add-contact {
        padding-left: 22px;
        cursor: pointer;
        background: url(../../assets/images/icon-add.png) no-repeat 0
          center;
        background-size: 18px 18px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #06AE63;
      }
    }
  }
}
</style>